import React from "react";
import { Tooltip } from "antd";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationOverviewFieldProps {
  task: TCommunicationTask;
}

const CommunicationOverviewField: React.FC<ICommunicationOverviewFieldProps> = ({ task }) => (
  <div className="communication-overview-field">
    <Tooltip title={task.event_name || "\u2014"}>
      <strong className="communication-overview-field__event">{task.event_name || "\u2014"}</strong>
    </Tooltip>
    <Tooltip title={task.company_name || "\u2014"}>
      <span className="communication-overview-field__company">{task.company_name || "\u2014"}</span>
    </Tooltip>
  </div>
);

export default CommunicationOverviewField;
